import {FxxlMelibo} from '@fxxl/melibo';

export const FxxlSideModal = (function FxxlSideModal()
{
    function FxxlSideModal(element)
    {
        var __this = this;
        this.element = element;
        this.overlay = $('<div class="fxxl-side-modal__overlay"></div>');
        this.header = $('<div class="fxxl-side-modal__header fxxl-side-modal__header--large"></div>');
        this.removeButton = $('<a href="#" class="fxxl-side-modal__header-closebutton"><svg width="24" height="24"><use href="#sprite_icon_close" xlink:href="#sprite_icon_close"></use></svg></a>');
        this.headerTitleMainText = this.element.attr('data-header-title');
        this.headerTitleIcon = this.element.attr('data-header-title-icon');
        this.headerTitle = $('<div class="fxxl-side-modal__header-title"></div>');
        this.headerTitleMain = $('<div class="fxxl-side-modal__header-title-main"></div>');
        this.headerSubtitleText = this.element.attr('data-header-subtitle');
        this.headerSubtitle = $('<div class="fxxl-side-modal__header-title-sub"></div>');
        this.activeClass = 'fxxl-side-modal--active';
        this.displayClass = 'fxxl-side-modal__overlay--show';
        this.supportWidget = undefined;
        this.supportWidgetClass = 'fxxl-support-widget';
        this.hiddenClass = 'fxxl-hidden';
        this.modalId = this.element.attr('id');
        this.triggerButtons = $("a[href='#"+this.modalId+"']");
        this.headerTitlePickText = 'Bitte Header Titel auswählen';
        this.onSideModalOpen = function () {};
        this.onSideModalClose = function () {};
        this.init();
    }

    FxxlSideModal.prototype.init = function init()
    {
        var __this = this;
        this.element.after(this.overlay);
        this.element.prepend(this.header);
        this.header.prepend(this.removeButton);
        this.header.prepend(this.headerTitle);

        this.supportWidget = document.querySelector(`.${this.supportWidgetClass}`);

        if (this.headerTitleMainText !== undefined) {
            if (this.headerTitleIcon !== undefined) {
                var iconHtml = `<svg width="24" height="24" class="fxxl-side-modal__header-title-main-icon"><use href="#${this.headerTitleIcon}"></use></svg>`;
                this.headerTitleMainText = iconHtml + this.headerTitleMainText;
            }
            this.headerTitleMain.html(this.headerTitleMainText);
        } else {
            this.headerTitleMain.html(this.headerTitlePickText);
        }
        this.headerTitle.append(this.headerTitleMain);

        if (this.headerSubtitleText !== undefined) {
            this.headerSubtitle.html(this.headerSubtitleText);
        } else {
            this.headerSubtitle.html(this.headerTitlePickText);
        }
        this.headerTitle.append(this.headerSubtitle);
        this.events();

        this.element[0].fxxlSideModal = this;
    }

    FxxlSideModal.prototype.hideSupportWidget = function hideSupportWidget() {
        setTimeout(() => {
            // Wir brauchen hier ein Timeout, damit die Lieferungsauswahl im Checkout2 auf dem Handy richtig funktioniert.

            if (this.supportWidget) {
                this.supportWidget?.fxxlSupportWidget.showHideWidget(false);
            }

            if (!isLargeViewport()) {
                FxxlMelibo.hideWidgetIcon();
            }
        }, 100);
    }

    FxxlSideModal.prototype.showSupportWidget = function showSupportWidget() {
        setTimeout(() => {
            // Wir brauchen hier ein Timeout, damit die Lieferungsauswahl im Checkout2 auf dem Handy richtig funktioniert.
            if (this.supportWidget) {
                this.supportWidget?.fxxlSupportWidget.showHideWidget(true);
            }

            if (!isLargeViewport()) {
                FxxlMelibo.showWidgetIcon();
            }
        }, 100);
    }

    FxxlSideModal.prototype.hideSideModal = function hideSideModal()
    {
        this.overlay.removeClass(this.displayClass);
        this.element.removeClass(this.activeClass);
        this.showSupportWidget();
        this.onSideModalClose();
    };

    FxxlSideModal.prototype.openSideModal = function openSideModal()
    {
        this.overlay.addClass(this.displayClass);
        this.element.addClass(this.activeClass);
        this.hideSupportWidget();
        this.onSideModalOpen();
    };

    FxxlSideModal.prototype.events = function events()
    {
        var __this = this;
        this.removeButton.on('click', function () {
            __this.hideSideModal();
            return false;
        });

        if (this.modalId !== undefined) {
            // Delegated binding keeps hash-trigger links working even if they are rendered later.
            $(document).on('click', "a[href='#" + this.modalId + "']", function () {
                __this.openSideModal();
                return false;
            });
        }

        this.overlay.on('click', function () {
            __this.hideSideModal();
            return false;
        });
    };

    return FxxlSideModal;
}());
